import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import OurPeopleListingImport from '../listings/OurPeopleListing/OurPeopleListingJsFile';

let store;

function OurPeopleApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<OurPeopleListingImport />
			</RouterProvider>
		</Provider>
	);
}

export function renderOurPeople(id) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('OurPeopleAppId'));
	router.start(() => {
		ReactDOM.render(<OurPeopleApp />, document.getElementById(id));
	});
}
